import React from 'react'
import { parseDateOnly } from './vehicleToQuote'

// The lower half of a Current Vehicle card: the car the customer has, where a
// quote card shows what a deal would cost. It renders inside QuoteCard's
// type-themed body, under the ownership + MSRP row that card already draws, so
// everything here inherits the card's own colours and typography.
//
// Every value can be unknown — a sale's odometer and payoff until Edit Car
// records them, a hand-recorded car's sticker price — and an unknown one renders blank
// rather than as a dash, an N/A or a zero nobody entered. The slots stay put,
// which is what keeps the cards in a row the same height.

const NBSP = ' '

// One rule for "we don't have this", so every slot blanks on the same terms.
// A recorded 0 is an answer and is not blank.
const unknown = (value) =>
    value === null || value === undefined || value === '' || Number.isNaN(Number(value))

// The CRM's money: whole dollars, as on the quote cards, the People rows and
// Reports. Blank, not "—", when there is nothing to show.
const money = (value) =>
    unknown(value) ? NBSP : `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`

const odometer = (value) => (unknown(value) ? NBSP : Number(value).toLocaleString())

// "Apr 20, 2027". parseDateOnly, never new Date(iso): a date-only value read as
// UTC midnight renders as the previous day west of Greenwich.
const fullDate = (iso) => {
    const date = parseDateOnly(iso)
    return date ? date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : NBSP
}

export const VehicleCardBody = ({ quote }) => (
    <>
        {/* The row stays even with no date in it, so every card's rows line
            up with the ones beside it. */}
        <div className="exp-row">{fullDate(quote.exp)}</div>

        <div className="stats-row">
            <div className="stat">
                <div className="val">{odometer(quote.odo)}</div>
                <div className="key">ODO</div>
            </div>
            <div className="stat">
                <div className="val">{money(quote.payoff)}</div>
                <div className="key">PAYOFF</div>
            </div>
        </div>
    </>
)
